import React, { useState } from 'react';

export function EmailVerificationNotice({
  email,
  message,
  getApiBaseUrl,
  sourceApp,
  onResent,
}) {
  const [resending, setResending] = useState(false);
  const [resendMessage, setResendMessage] = useState('');
  const [resendError, setResendError] = useState('');

  const handleResend = async () => {
    if (!email) {
      return;
    }
    setResending(true);
    setResendMessage('');
    setResendError('');
    try {
      const response = await fetch(`${getApiBaseUrl()}/auth/resend-verification-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          ...(sourceApp ? { source_app: sourceApp } : {}),
        }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.detail || 'Could not resend verification email.');
      }
      const successText = data.message || 'Verification email sent. Check your inbox.';
      setResendMessage(successText);
      onResent?.(successText);
    } catch (error) {
      setResendError(error.message || 'Could not resend verification email.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="mb-4 p-4 bg-amber-50 border border-amber-200 rounded-md space-y-3">
      <p className="text-sm text-amber-900">{message}</p>
      {email && (
        <p className="text-sm text-amber-800">
          Verification email sent to <strong>{email}</strong>.
        </p>
      )}
      <button
        type="button"
        onClick={handleResend}
        disabled={resending || !email}
        className="w-full py-2 px-4 rounded-md bg-amber-600 text-white text-sm font-medium hover:bg-amber-700 disabled:opacity-50"
      >
        {resending ? 'Sending...' : 'Resend verification email'}
      </button>
      {resendMessage && <p className="text-sm text-green-700">{resendMessage}</p>}
      {resendError && <p className="text-sm text-red-600">{resendError}</p>}
    </div>
  );
}
